import { z } from 'zod';

export const clientFormSchema = z.object({
  name: z.string().min(1, 'Nome é obrigatório'),
  email: z.string().min(1, 'E-mail é obrigatório').email('E-mail inválido'),
  whatsapp: z.string().optional(),
});

export type ClientFormData = z.infer<typeof clientFormSchema>;
